import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
// Models
import { serializeMe } from 'models/user';
// Custom
import localeManager from 'intl/LocalesManager';
import { updateMe, changeLocale } from 'actions';
import { FlagImg } from 'components/img/AssetImg';
import { meDataShape } from 'constants/PropTypesShapes';
// Models
import mProduct from 'models/product';

const product = __PRODUCT__; // eslint-disable-line no-undef
const productAvailableLocales = localeManager.getAvailableLocales().filter(({ locale }) => mProduct.getAuthorizedLocales(product).includes(locale));

const useStyles = makeStyles(() => ({
  flagContainer: {
    borderRadius: 5,
    overflow: 'hidden',
    cursor: 'pointer',
    width: '100%',
    scale: 0.7,
  },
}));

const LangSelector = ({
  locale: currentLocale,
  countryCode: currentCountryCode,
  loggedIn,
  dispatchUpdateMe,
  dispatchChangeLocale,
  me,
}) => {
  const classes = useStyles();

  const handleLocaleChange = (locale) => {
    if (loggedIn && me) {
      // User is connected => update it before changing locale
      dispatchUpdateMe(serializeMe({
        ...me,
        locale,
      }));
    }

    dispatchChangeLocale(locale);
  };

  const langsAvailable = productAvailableLocales.map(({
    locale,
    desc,
    countryCode,
  }) => ({
    locale,
    label: desc,
    countryCode,
    icon: <FlagImg countryCode={countryCode} />,
    disabled: locale === currentLocale,
    handleAction: () => handleLocaleChange(locale),
    visible: true,
  }));

  const langsToSwitch = langsAvailable.filter(({ countryCode }) => countryCode !== currentCountryCode);

  return (
    <div className="d-flex" style={{ gap: '15px' }}>
      {langsToSwitch
        .map(({ countryCode, locale }) => (
          <div onClick={() => handleLocaleChange(locale)} className={classes.flagContainer} role="button" tabIndex={0} key={locale}>
            <FlagImg countryCode={String(countryCode)} />
          </div>
        ))}
    </div>
  );
};

LangSelector.propTypes = {
  locale: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  dispatchUpdateMe: PropTypes.func.isRequired,
  dispatchChangeLocale: PropTypes.func.isRequired,
  me: meDataShape,
};

const mapStateToProps = (state) => ({
  locale: state.intl.locale,
  countryCode: state.intl.countryCode,
  loggedIn: state.auth.loggedIn,
  me: state.me.data,
});

LangSelector.defaultProps = {
  me: null,
};

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateMe: (data) => {
    dispatch(updateMe(data));
  },
  dispatchChangeLocale: (locale) => {
    dispatch(changeLocale(locale));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LangSelector);



// WEBPACK FOOTER //
// ./components/misc/LangSelector.js